import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'PayPoint/Select');
};

export const ViewBeneficiary = async (request) => {
    return PostAPI(request, 'PayPoint/ViewBeneficiary');
};

export const SenderRegistration = async (request) => {
    return PostAPI(request, 'PayPoint/SenderRegistration');
};

export const VerifyOTP = async (request) => {
    return PostAPI(request, 'PayPoint/VerifyOTP');
};

export const GenreateAadharOTP = async (request) => {
    return PostAPI(request, 'PayPoint/GenreateAadharOTP');
};

export const ResendAadharOTP = async (request) => {
    return PostAPI(request, 'PayPoint/ResendAadharOTP');
};

export const ValidateAadharOTP = async (request) => {
    return PostAPI(request, 'PayPoint/ValidateAadharOTP');
};

export const PanCardKYC = async (request) => {
    return PostAPI(request, 'PayPoint/PanCardKYC');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'PayPoint/AddBeneficiary');
};

export const VerifyBeneficiaryAndAdd = async (request) => {
    return PostAPI(request, 'PayPoint/VerifyBeneficiaryAndAdd');
};

export const GenerateOTPForBeneficiaryDelete = async (request) => {
    return PostAPI(request, 'PayPoint/GenerateOTPForBeneficiaryDelete');
};

export const DeleteBeneficiaryVerifyOTP = async (request) => {
    return PostAPI(request, 'PayPoint/DeleteBeneficiaryVerifyOTP');
};

export const GenerateOTPForTransfer = async (request) => {
    return PostAPI(request, 'PayPoint/GenerateOTPForTransfer');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'PayPoint/MoneyTransfer');
};

export const CheckTxnStatus = async (request) => {
    return PostAPI(request, 'PayPoint/CheckTxnStatus');
};

export const GenerateRefundOTP = async (request) => {
    return PostAPI(request, 'PayPoint/GenerateRefundOTP');
};

export const ValidateOTPAndRefund = async (request) => {
    return PostAPI(request, 'PayPoint/ValidateOTPAndRefund');
};

export const SelectTransferModeByIFSC = async (request) => {
    return PostAPI(request, 'PayPoint/SelectTransferModeForIFSC');
};

